// src/utils/cookieUtils.js

/**
 * 쿠키 값 가져오기
 * @param {string} name
 * @returns {string|null}
 */
export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return null;
}

/**
 * 쿠키 설정 (분 단위로 유효 시간 설정)
 * @param {string} name
 * @param {string} value
 * @param {number} minutes
 */
export function setCookieMinutes(name, value, minutes) {
    const expires = new Date();
    expires.setTime(expires.getTime() + minutes * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}